module.exports = __webpack_public_path__ + "img/topold.7e853353.png";